
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AdminAccess() {
  const navigate = useNavigate();

  useEffect(() => {
    // Gizli admin erişimi - direkt admin sayfasına yönlendir
    const timer = setTimeout(() => {
      navigate('/noxsanat/admin');
    }, 1000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
        <p className="text-gray-300">Admin paneline yönlendiriliyor...</p>
      </div>
    </div>
  );
}
